export const ApprovalStatus = {
  Approved: 'approved',
  Deleted: 'deleted',
  Failed: 'failed',
  Pending: 'pending',
  Rejected: 'rejected',
} as const;

export type ApprovalStatus =
  (typeof ApprovalStatus)[keyof typeof ApprovalStatus];
